import { render, staticRenderFns } from "./DownloadElectronCard.vue?vue&type=template&id=1537bd1b&"
import script from "./DownloadElectronCard.vue?vue&type=script&lang=js&"
export * from "./DownloadElectronCard.vue?vue&type=script&lang=js&"
import style0 from "./DownloadElectronCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports